import { useCallback } from 'react'

import { TeamRole } from '@/consts/team'
import CreateFolderBase from '@/pages/data-mgr/core/components/CreateFolderBase'
import type { IFile } from '@/pages/data-mgr/core/types'

import * as teamFs from './fs'

interface TeamCreateFolderProps {
  dir: string
  files?: IFile[]
  domain: number
  userRole: TeamRole
  teamId: number
  onOk?: () => void
  disabled?: boolean
}

export default function TeamCreateFolder({
  dir,
  files,
  domain,
  userRole,
  teamId,
  onOk,
  disabled = false,
}: TeamCreateFolderProps) {
  const onCreate = useCallback(
    async (folderName: string) => {
      await teamFs.mkdir({
        path: `${dir}${folderName}/`,
        domain,
        userRole,
        teamId,
      })
    },
    [dir, domain, userRole, teamId],
  )

  return (
    <CreateFolderBase dir={dir} files={files} onCreate={onCreate} onOk={onOk} disabled={disabled} />
  )
}
